/**
 * State Management für das Rating Widget
 * Implementiert ein einfaches Observable Pattern für State-Änderungen
 */

// Globaler State für Artikel-Bewertungen, wird über alle Widgets geteilt
window.RatingGlobalState = window.RatingGlobalState || {
    // Map von PID zu Bewertungsstatus
    ratedPages: new Map()
};

// Globaler Event-Emitter für Änderungen am Bewertungsstatus
window.dispatchRatingStateEvent = function(pid, hasRated) {
    window.RatingGlobalState.ratedPages.set(pid, hasRated);
    
    // Custom Event mit Rating-Status-Daten erstellen
    const stateEvent = new CustomEvent('rating-state-changed', {
        bubbles: true,
        detail: {
            pid: pid,
            hasRated: hasRated,
            timestamp: Date.now()
        }
    });
    
    // Event auslösen
    document.dispatchEvent(stateEvent);
};

export class RatingState {
    constructor() {
        this.observers = new Set()
        this.state = {
            currentRating: 0,
            userRating: 0,
            hasRated: false,
            isSubmitting: false,
            error: null,
            isInteractive: false,
            debugMode: false,
            showFeedbackModal: false,
            // feedbackModalLink removed
            translations: {
                alreadyRated: '',
                submitting: '',
                thankYou: '',
                error: '',
                tooltip: '',
                modalTitle: '',
                modalSubmit: '',
                modalCancel: '',
                modalHeader: '',
                modalDescription: '',
                botError: '',
                feedbackModalTitle: '',
                feedbackModalHeader: '',
                feedbackModalDescription: '',
                feedbackModalInputLabel: '',
                feedbackModalSubmit: '',
                feedbackModalCancel: '',
                feedbackModalThankYou: '',
            },
        }
    }

    subscribe(observer) {
        this.observers.add(observer)
        observer(this.state)
        return () => this.observers.delete(observer)
    }

    setState(newState) {
        this.state = { ...this.state, ...newState }
        this.observers.forEach((observer) => observer(this.state))
    }

    getState() {
        return this.state
    }
}

export const createStore = () => new RatingState()
